const translation = {
  title: '审计日志',
  detail: {
    title: '审计日志详情',
  },
  list: {
    search: '搜索',
    empty_text: '暂无数据',
    columns: {
      id: 'ID',
      project: '项目',
      user: '用户',
      operation: '操作',
      resource: '资源',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      actions: '操作',
    },
    actions: {
      view: '查看',
    },
  },
  form: {
    project: '项目',
    projectTooltip: '操作所属的项目名称',
    user: '用户',
    userTooltip: '执行操作的用户账号',
    operation: '操作',
    operationTooltip: '用户执行的操作类型，如创建、更新、删除等',
    resource: '资源',
    resourceTooltip: '操作涉及的资源类型和名称',
    queryString: '查询参数',
    queryStringTooltip: '请求URL中携带的查询参数',
    body: '请求体',
    bodyTooltip: '请求中携带的数据内容（JSON格式）',
    result: '结果',
    resultTooltip: '操作执行的结果状态，如成功或失败',
    response: '响应',
    responseTooltip: '服务器返回的响应数据内容',
    createdAt: '创建时间',
    createdAtTooltip: '审计日志的记录时间',
    confirm: '确定',
    cancel: '取消',
  },
}

export default translation
